module.exports = __webpack_public_path__ + "static/media/city_park_1.19bc7ff8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/RestaurantAndCafe/images/city_park_1.jpg
// module id = 359
// module chunks = 0